var exports = {
  "Q": "xa15a2ab7--61b48b--content",
  "C": "xa15a2ab7--61b48b--animated",
};

module.exports = exports;
